import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import DetailPageLayout from "../../../components/detail/DetailPageLayout";
import faqService from "../../../services/faqService";
import { instanceToken } from "../../../utils/constant";
import { dateInfoItems, formatAnswerList } from "../../../utils/detailUtils";

const DetailFaq = ({ homeAlert }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [faq, setFaq] = useState(null);

  useEffect(() => {
    const fetchFaq = async () => {
      try {
        const res = await faqService.getAllFaq(instanceToken.token, id);
        setFaq(res.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchFaq();
  }, [id]);

  const handleRemove = async () => {
    try {
      await faqService.deleteFaq(instanceToken.token, id);
      homeAlert("FAQ has been removed.", false);
      navigate("/faqs");
    } catch (error) {
      console.log(error);
      homeAlert("Error on server!", true);
    }
  };

  const answerText = faq ? formatAnswerList(faq.answers) : "";

  return (
    <DetailPageLayout
      title="FAQ Details"
      subtitle="View and manage frequently asked question"
      breadcrumbs={[
        { label: "FAQs", path: "/faqs" },
        { label: `FAQ (ID - ${id})` },
      ]}
      listPath="/faqs"
      loading={!faq}
      editPath={faq ? `/faqs/edit/${faq.id}` : undefined}
      onRemove={handleRemove}
      contentSections={
        answerText
          ? [
              {
                title: "Answers",
                value: answerText,
                icon: "notes",
              },
            ]
          : []
      }
      infoItems={
        faq
          ? [
              { label: "ID", value: String(faq.id), icon: "id" },
              {
                label: "Category (English)",
                value: faq.category_en,
                icon: "category",
              },
              {
                label: "Category (Myanmar)",
                value: faq.category_mm,
                icon: "category",
                myanmar: true,
              },
              {
                label: "Question (English)",
                value: faq.question_en,
                icon: "title",
              },
              {
                label: "Question (Myanmar)",
                value: faq.question_mm,
                icon: "title",
                myanmar: true,
              },
              ...dateInfoItems(faq),
            ]
          : []
      }
      infoTitle="FAQ Information"
    />
  );
};

export default DetailFaq;
